import {createSelector} from 'reselect'
import {isUserAuthenticatedSelector} from 'selectors/authSelectors'
import {appRoutes} from 'constants/appRoutesConstants'

export const availableRoutesSelector = createSelector([isUserAuthenticatedSelector], isLoggedIn => {
  return isLoggedIn ? appRoutes : appRoutes.filter(route => !route.authenticated)
})
